// Порядок отзывов на главной.
//
// Отзыв — слова человека, и переводить их не нужно: семья на азербайджанской
// странице прочтёт русский отзыв так же, как на русской. Прежде блок
// показывал только отзывы языка страницы, и на /az и /en при двух одобренных
// русских отзывах стоял пустой заголовок (замер 01.10).
//
// Теперь — все одобренные: сначала те, чей ТЕКСТ на языке страницы, дальше
// остальные с пометкой языка (05.10.2026), внутри
// каждой части новые раньше старых.

export type PublicReview = {
  id: string;
  name: string;
  child_age: string | null;
  text: string;
  rating: number;
  lang: string;
  created_at: string;
};

export type ReviewTextLang = "ru" | "az" | "en";

/**
 * Язык ТЕКСТА отзыва — по алфавиту, а не по reviews.lang. lang — язык
 * страницы, с которой отзыв отправили: у b12bebd9 текст английский, а lang
 * ru. Правило владельца (05.10.2026): кириллица — ru, латиница с буквами
 * ə ğ ı ş ç ö ü — az, иначе en.
 */
export function reviewTextLang(text: string): ReviewTextLang {
  if (/[А-Яа-яЁё]/.test(text)) return "ru";
  if (/[əğışçöüƏĞİŞÇÖÜ]/.test(text)) return "az";
  return "en";
}

export function orderReviews(rows: PublicReview[], lang: string, limit = 20): (PublicReview & { text_lang: ReviewTextLang })[] {
  return rows
    .map((r) => ({ ...r, text_lang: reviewTextLang(r.text) }))
    .sort(
      (a, b) =>
        Number(b.text_lang === lang) - Number(a.text_lang === lang) ||
        b.created_at.localeCompare(a.created_at) ||
        a.id.localeCompare(b.id),
    )
    .slice(0, limit);
}
